import React from "react";

import { Tooltip } from "@material-ui/core";
import { green, orange, red } from "@material-ui/core/colors";
import { ExternalStatus } from "../../utils/constants";
import { ImportExportFailedIcon, ImportExportIcon } from "./iconography";

export const ExternalStatusIcon = ({ record }) => {
  if (!record?.externalStatus) return null;

  const icon = () => {
    switch (record.externalStatus) {
      case ExternalStatus.SYNC_PENDING:
        return (
          <Tooltip title="Pending Sync" placement="right" arrow>
            <ImportExportIcon style={{ color: orange[700] }} />
          </Tooltip>
        );
      case ExternalStatus.SYNCED:
        return (
          <Tooltip title="Synced" placement="right" arrow>
            <ImportExportIcon style={{ color: green[700] }} />
          </Tooltip>
        );
      default:
        return (
          <Tooltip title="Sync Failed" placement="right" arrow>
            <ImportExportFailedIcon style={{ color: red[700] }} />
          </Tooltip>
        );
    }
  };

  return icon();
};
